/**
 * audio_utils.js
 *
 * 純音訊工具函式：
 * - mono conversion
 *
 * 不涉及任何 UI / WebSocket / ASR 邏輯
 *
 * 這裡曾有一支 downsample()，實作是 nearest-neighbor 抽點、沒有抗混疊低通，
 * 也不保留跨 frame 相位（實測混疊 +24.28 dB、輸出實際只有 15975.5 Hz）。它已被
 * 刪除而非保留成 fallback：留著只會被下一個人當成「現成的重採樣工具」再用一次。
 * 需要重採樣一律走 audio_resampler.js。
 */

/**
 * 將多聲道 audio buffer 轉為 mono
 * @param {Array<Float32Array>} channels
 * @returns {Float32Array}
 */
export function toMono(channels) {
  if (!channels || channels.length === 0) {
    throw new Error("Invalid audio channels");
  }

  if (channels.length === 1) {
    return channels[0];
  }

  const length = channels[0].length;
  const mono = new Float32Array(length);

  for (let i = 0; i < length; i++) {
    let sum = 0;
    for (let ch = 0; ch < channels.length; ch++) {
      sum += channels[ch][i];
    }
    mono[i] = sum / channels.length;
  }

  return mono;
}
